import { type AppModuleCode } from '@gb-ticket/shared-types';

import { isModuleEnabled } from './permissions';
import { useMe } from './use-me';

export function useModule(code: AppModuleCode): boolean {
  const me = useMe();
  return isModuleEnabled(me.data, code);
}
